import { render, staticRenderFns } from "./select-linker.vue?vue&type=template&id=2a35ab74&scoped=true"
import script from "./select-linker.vue?vue&type=script&lang=js"
export * from "./select-linker.vue?vue&type=script&lang=js"
import style0 from "./select-linker.vue?vue&type=style&index=0&id=2a35ab74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a35ab74",
  null
  
)

export default component.exports